import EventBG from "../../../../../assets/images/event-list.webp";
import { Link } from "react-router-dom";
import Image from "../../../../../components/elements/Image";
import OtpVerificationForm from "../../../../../components/sections/front/Authentication/OtpVerificationForm";

const OptVerification = () => {
  return (
    <div className="flex items-center justify-center bg-gradient-to-br from-[#F9F6FF] to-[#F4F1FD] p-6 relative">
      <div className="p-2 border-2 border-white rounded-4xl overflow-hidden max-w-6xl w-full">
        <div className="grid grid-cols-12  bg-white rounded-4xl overflow-hidden">
          <div className="col-span-6 py-14 px-20 flex flex-col justify-center">
            <Link
              to="/"
              className="w-48 overflow-hidden aspect-[7/1] block mb-5"
            >
              <Image
                src={require("../../../../../assets/images/logo.png")}
                classes={"object-contain"}
              />
            </Link>
            <h1 className="text-2xl font-bold text-deep-purple mb-1">
              Welcome! Verify your account
            </h1>
            <OtpVerificationForm />
          </div>
          <div className="col-span-6 pt-5 pr-5 pb-5 pl-0">
            <div className="space-y-5 rounded-2xl overflow-hidden bg-gradient-to-br from-[#F9F6FF] to-[#F4F1FD] py-14 pl-10 flex flex-col w-full">
              <div className="capitalize text-slate-500 text-xs bg-white border border-text-disabled rounded-md p-1 max-w-60 text-center flex items-center justify-center">
                dancebrite system pressure control
              </div>
              <div className="text-slate-500 font-medium text-base max-w-96 w-full">
                Manage your concreting and construction operation{" "}
                <span className="text-deep-purple0">more professionally</span>
              </div>
              <div className="w-full aspect-[5/4] overflow-hidden">
                <Image src={EventBG} classes={"object-cover"} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-decoration bg-decoration-1"></div>
      <div className="bg-decoration bg-decoration-2"></div>
      <div className="bg-decoration bg-decoration-3"></div>
    </div>
  );
};

export default OptVerification;
